// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var STEM__Client$SmartcutsMacros = require("../../../../../bs-data-extraction/src/STEM__Client.bs.js");
var StateMachine$SmartcutsMacros = require("../../../StateMachine.bs.js");
var DOM__HtmlElement$SmartcutsMacros = require("../../../DOM__HtmlElement.bs.js");
var STEM__Interfaces$SmartcutsMacros = require("../../../../../bs-data-extraction/src/STEM__Interfaces.bs.js");
var DataExtraction__DataRecord$SmartcutsMacros = require("../../../../../bs-data-extraction/src/DataExtraction__DataRecord.bs.js");
var DataExtraction__DataRegion$SmartcutsMacros = require("../../../../../bs-data-extraction/src/DataExtraction__DataRegion.bs.js");
var DataExtraction__ExportToTable$SmartcutsMacros = require("../../../../../bs-data-extraction/src/DataExtraction__ExportToTable.bs.js");
var ExtensionMessaging__FromExtension$SmartcutsMacros = require("../../../ExtensionMessaging__FromExtension.bs.js");
var ContentScript__StateMachine__Shared$SmartcutsMacros = require("../ContentScript__StateMachine__Shared.bs.js");
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = require("../ContentScript__StateMachine__Shared__Types.bs.js");

function t_encode(encoder_htmlElement, v) {
  return [
          "STEM",
          STEM__Client$SmartcutsMacros.Generic.t_encode(encoder_htmlElement, v._0)
        ];
}

function t_decode(decoder_htmlElement, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "STEM") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = STEM__Client$SmartcutsMacros.Generic.t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* STEM */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function mapHtmlElement(mapHtmlElement$1, client) {
  var func = STEM__Client$SmartcutsMacros.Generic.mapHtmlElement;
  return /* STEM */{
          _0: Curry._2(func, mapHtmlElement$1, client._0)
        };
}

var Client = {
  t_encode: t_encode,
  t_decode: t_decode,
  mapHtmlElement: mapHtmlElement
};

function t_encode$1(v) {
  return [
          "STEM",
          STEM__Interfaces$SmartcutsMacros.signal_encode(v._0)
        ];
}

function t_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "STEM") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = STEM__Interfaces$SmartcutsMacros.signal_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* STEM */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var Signal = {
  t_encode: t_encode$1,
  t_decode: t_decode$1
};

function entry_decode(decoder_htmlElement, decoder_textNode, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var dataRecord = DataExtraction__DataRecord$SmartcutsMacros.WithDomElementOrTextNode.t_decode(decoder_htmlElement, decoder_textNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataRecord"), null));
  if (dataRecord.TAG === /* Ok */0) {
    var dataRegion = DataExtraction__DataRegion$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataRegion"), null));
    if (dataRegion.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                dataRecord: dataRecord._0,
                dataRegion: dataRegion._0
              }
            };
    }
    var e = dataRegion._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".dataRegion" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = dataRecord._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".dataRecord" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function entry_encode(encoder_htmlElement, encoder_textNode, v) {
  return Js_dict.fromArray([
              [
                "dataRecord",
                DataExtraction__DataRecord$SmartcutsMacros.WithDomElementOrTextNode.t_encode(encoder_htmlElement, encoder_textNode, v.dataRecord)
              ],
              [
                "dataRegion",
                DataExtraction__DataRegion$SmartcutsMacros.t_encode(v.dataRegion)
              ]
            ]);
}

function t_encode$2(encoder_htmlElement, encoder_textNode, v) {
  return Decco.arrayToJson((function (param) {
                return entry_encode(encoder_htmlElement, encoder_textNode, param);
              }), v);
}

function t_decode$2(decoder_htmlElement, decoder_textNode, v) {
  return Decco.arrayFromJson((function (param) {
                return entry_decode(decoder_htmlElement, decoder_textNode, param);
              }), v);
}

function mapHtmlElement$1(mapHtmlElement$2, entries) {
  return Belt_Array.map(entries, (function (param) {
                var func = DataExtraction__DataRecord$SmartcutsMacros.WithDomElementOrTextNode.mapHtmlElement;
                return {
                        dataRecord: Curry._2(func, mapHtmlElement$2, param.dataRecord),
                        dataRegion: param.dataRegion
                      };
              }));
}

var DataRecords = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  entry_encode: entry_encode,
  entry_decode: entry_decode,
  mapHtmlElement: mapHtmlElement$1
};

function state_encode(encoder_htmlElement, v) {
  if (typeof v === "number") {
    switch (v) {
      case /* Init */0 :
          return ["Init"];
      case /* Initializing */1 :
          return ["Initializing"];
      case /* Exiting */2 :
          return ["Exiting"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* ExtractingSignal */0 :
          return [
                  "ExtractingSignal",
                  t_encode(encoder_htmlElement, v._0)
                ];
      case /* ProcessingSignal */1 :
          return [
                  "ProcessingSignal",
                  t_encode(encoder_htmlElement, v._0)
                ];
      case /* SelectingDataToExport */2 :
          return [
                  "SelectingDataToExport",
                  t_encode(encoder_htmlElement, v._0),
                  Decco.arrayToJson((function (param) {
                          return Decco.arrayToJson(DataExtraction__DataRegion$SmartcutsMacros.t_encode, param);
                        }), v._1)
                ];
      
    }
  }
}

function state_decode(decoder_htmlElement, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Exiting" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Exiting */2
                  };
          }
      case "ExtractingSignal" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ExtractingSignal */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Init" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Init */0
                  };
          }
      case "Initializing" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Initializing */1
                  };
          }
      case "ProcessingSignal" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ProcessingSignal */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "SelectingDataToExport" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.arrayFromJson((function (param) {
                  return Decco.arrayFromJson(DataExtraction__DataRegion$SmartcutsMacros.t_decode, param);
                }), Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* SelectingDataToExport */2,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$2 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function selectingDataToExport_encode(encoder_htmlElement, encoder_textNode, v) {
  return Js_dict.fromArray([
              [
                "client",
                t_encode(encoder_htmlElement, v.client)
              ],
              [
                "dataRecords",
                t_encode$2(encoder_htmlElement, encoder_textNode, v.dataRecords)
              ],
              [
                "columns",
                Decco.arrayToJson((function (param) {
                        return DataExtraction__ExportToTable$SmartcutsMacros.column_encode(DataExtraction__DataRecord$SmartcutsMacros.Schema.WithHTPIAndTagPathAndDataNodeId.dataSchema_encode, param);
                      }), v.columns)
              ],
              [
                "rows",
                Decco.arrayToJson((function (param) {
                        return Decco.arrayToJson((function (param) {
                                      return Decco.optionToJson(Decco.stringToJson, param);
                                    }), param);
                      }), v.rows)
              ]
            ]);
}

function selectingDataToExport_decode(decoder_htmlElement, decoder_textNode, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var client = t_decode(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "client"), null));
  if (client.TAG === /* Ok */0) {
    var dataRecords = t_decode$2(decoder_htmlElement, decoder_textNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataRecords"), null));
    if (dataRecords.TAG === /* Ok */0) {
      var columns = Decco.arrayFromJson((function (param) {
              return DataExtraction__ExportToTable$SmartcutsMacros.column_decode(DataExtraction__DataRecord$SmartcutsMacros.Schema.WithHTPIAndTagPathAndDataNodeId.dataSchema_decode, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "columns"), null));
      if (columns.TAG === /* Ok */0) {
        var rows = Decco.arrayFromJson((function (param) {
                return Decco.arrayFromJson((function (param) {
                              return Decco.optionFromJson(Decco.stringFromJson, param);
                            }), param);
              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "rows"), null));
        if (rows.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    client: client._0,
                    dataRecords: dataRecords._0,
                    columns: columns._0,
                    rows: rows._0
                  }
                };
        }
        var e = rows._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".rows" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = columns._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".columns" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = dataRecords._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".dataRecords" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = client._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".client" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function event_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v) {
  switch (v.TAG | 0) {
    case /* Initialize */0 :
        return [
                "Initialize",
                ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._0)
              ];
    case /* BasicEventWhileDataExtraction */1 :
        return [
                "BasicEventWhileDataExtraction",
                ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_encode(v._0)
              ];
    case /* Fail */2 :
        return [
                "Fail",
                failure_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v._0)
              ];
    case /* DidInitializeClient */3 :
        return [
                "DidInitializeClient",
                t_encode(encoder_htmlElement, v._0)
              ];
    case /* DidExtractSignal */4 :
        return [
                "DidExtractSignal",
                t_encode$1(v._0)
              ];
    case /* DidExtractDataRecords */5 :
        return [
                "DidExtractDataRecords",
                Decco.arrayToJson((function (param) {
                        return Decco.arrayToJson(DataExtraction__DataRegion$SmartcutsMacros.t_encode, param);
                      }), v._0)
              ];
    case /* Exit */6 :
        return [
                "Exit",
                exitReason_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v._0)
              ];
    
  }
}

function failure_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_encode, (function (param) {
                return state_encode(encoder_htmlElement, param);
              }), (function (param) {
                return event_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return sideEffect_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return ["NoListener"];
              }), otherFailureReason_encode, v);
}

function exitReason_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_encode, (function (param) {
                return state_encode(encoder_htmlElement, param);
              }), (function (param) {
                return event_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return sideEffect_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return ["NoListener"];
              }), otherFailureReason_encode, v);
}

function sideEffect_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AskBgToProcessDataExtractionSignal" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = t_decode$1(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* AskBgToProcessDataExtractionSignal */2,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Dispatch" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = event_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Dispatch */0,
                      _0: v0._0
                    }
                  };
          }
          var e$2 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "ExtractSignal" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ExtractSignal */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$3 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "InitializeClient" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* InitializeClient */0
                  };
          }
      case "RemoveDataExportWidget" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RemoveDataExportWidget */2
                  };
          }
      case "RenderDataExportWidget" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = Decco.arrayFromJson((function (param) {
                  return Decco.arrayFromJson(DataExtraction__DataRegion$SmartcutsMacros.t_decode, param);
                }), Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* RenderDataExportWidget */3,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$4 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "RenderInitialLoadingOverlay" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RenderInitialLoadingOverlay */1
                  };
          }
      case "RespondToBg" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$5 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$6 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.response_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$5.TAG === /* Ok */0) {
            if (match$6.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* RespondToBg */4,
                        _0: match$5._0,
                        _1: match$6._0
                      }
                    };
            }
            var e$6 = match$6._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$6.path,
                      message: e$6.message,
                      value: e$6.value
                    }
                  };
          }
          var e$7 = match$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var otherFailureReason_decode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_decode;

function event_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BasicEventWhileDataExtraction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* BasicEventWhileDataExtraction */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidExtractDataRecords" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.arrayFromJson((function (param) {
                  return Decco.arrayFromJson(DataExtraction__DataRegion$SmartcutsMacros.t_decode, param);
                }), Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidExtractDataRecords */5,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "DidExtractSignal" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = t_decode$1(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidExtractSignal */4,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "DidInitializeClient" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidInitializeClient */3,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "Exit" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = exitReason_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Exit */6,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "Fail" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = failure_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Fail */2,
                      _0: v0$5._0
                    }
                  };
          }
          var e$5 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "Initialize" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Initialize */0,
                      _0: v0$6._0
                    }
                  };
          }
          var e$6 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function listener_decode(decoder_domMutationRecord, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "NoListener") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* NoListener */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function failure_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_decode, (function (param) {
                return state_decode(decoder_htmlElement, param);
              }), (function (param) {
                return event_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return sideEffect_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return listener_decode(decoder_domMutationRecord, param);
              }), otherFailureReason_decode, v);
}

function exitReason_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_decode, (function (param) {
                return state_decode(decoder_htmlElement, param);
              }), (function (param) {
                return event_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return sideEffect_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return listener_decode(decoder_domMutationRecord, param);
              }), otherFailureReason_decode, v);
}

var otherFailureReason_encode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_encode;

function sideEffect_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v) {
  if (typeof v === "number") {
    switch (v) {
      case /* InitializeClient */0 :
          return ["InitializeClient"];
      case /* RenderInitialLoadingOverlay */1 :
          return ["RenderInitialLoadingOverlay"];
      case /* RemoveDataExportWidget */2 :
          return ["RemoveDataExportWidget"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* Dispatch */0 :
          return [
                  "Dispatch",
                  event_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v._0)
                ];
      case /* ExtractSignal */1 :
          return [
                  "ExtractSignal",
                  t_encode(encoder_htmlElement, v._0)
                ];
      case /* AskBgToProcessDataExtractionSignal */2 :
          return [
                  "AskBgToProcessDataExtractionSignal",
                  t_encode(encoder_htmlElement, v._0),
                  t_encode$1(v._1)
                ];
      case /* RenderDataExportWidget */3 :
          return [
                  "RenderDataExportWidget",
                  t_encode(encoder_htmlElement, v._0),
                  Decco.arrayToJson((function (param) {
                          return Decco.arrayToJson(DataExtraction__DataRegion$SmartcutsMacros.t_encode, param);
                        }), v._1)
                ];
      case /* RespondToBg */4 :
          return [
                  "RespondToBg",
                  ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._0),
                  ExtensionMessaging__FromExtension$SmartcutsMacros.All.response_encode(v._1)
                ];
      
    }
  }
}

function listener_encode(encoder_domMutationRecord, v) {
  return ["NoListener"];
}

function errorContext_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_encode, (function (param) {
                return state_encode(encoder_htmlElement, param);
              }), (function (param) {
                return event_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return sideEffect_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return ["NoListener"];
              }), v);
}

function errorContext_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, v) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_decode, (function (param) {
                return state_decode(decoder_htmlElement, param);
              }), (function (param) {
                return event_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return sideEffect_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return listener_decode(decoder_domMutationRecord, param);
              }), v);
}

function stringifyState(param, state) {
  if (typeof state === "number") {
    switch (state) {
      case /* Init */0 :
          return "Init";
      case /* Initializing */1 :
          return "Initializing";
      case /* Exiting */2 :
          return "Exiting";
      
    }
  } else {
    switch (state.TAG | 0) {
      case /* ExtractingSignal */0 :
          return "ExtractingSignal(STEM(client))";
      case /* ProcessingSignal */1 :
          return "ProcessingSignal(STEM(client))";
      case /* SelectingDataToExport */2 :
          return "SelectingDataToExport(client: STEM(client), dataRecordsGroupedByFirstNode)";
      
    }
  }
}

function stringifyEvent(stringifyHtmlElement, stringifyBasicEvent, stringifyDomEvent, $$event) {
  switch ($$event.TAG | 0) {
    case /* Initialize */0 :
        return "Initialize(respondToBg)";
    case /* BasicEventWhileDataExtraction */1 :
        return "BasicEventWhileDataExtraction(" + (Curry._1(stringifyBasicEvent, $$event._0) + ")");
    case /* Fail */2 :
        var failure = $$event._0;
        var func = StateMachine$SmartcutsMacros.Failure.WithListener.stringify;
        var param = function (param$1) {
          return stringifyState(stringifyHtmlElement, param$1);
        };
        var func$1 = Curry._1(func, param);
        return "Fail(" + (Curry._3((function (param) {
                          var func$2 = Curry._1(func$1, param);
                          return function (param) {
                            var func$3 = Curry._1(func$2, param);
                            return function (param) {
                              var func$4 = Curry._1(func$3, param);
                              return function (param) {
                                return Curry._2(func$4, param, failure);
                              };
                            };
                          };
                        })(function (param) {
                          return stringifyEvent(stringifyHtmlElement, stringifyBasicEvent, stringifyDomEvent, param);
                        }), (function (param) {
                        return stringifySideEffect(stringifyHtmlElement, stringifyBasicEvent, stringifyDomEvent, param);
                      }), stringifyListener, stringifyOtherFailureReason) + ")");
    case /* DidInitializeClient */3 :
        return "DidInitializeClient(STEM(client))";
    case /* DidExtractSignal */4 :
        return "DidExtractSignal(STEM(signal))";
    case /* DidExtractDataRecords */5 :
        return "DidExtractDataRecords([n=" + (String($$event._0.length) + "])");
    case /* Exit */6 :
        var exitReason = $$event._0;
        var func$2 = StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.stringify;
        var param$1 = function (param$2) {
          return stringifyState(stringifyHtmlElement, param$2);
        };
        var func$3 = Curry._1(func$2, param$1);
        return "Exit(" + (Curry._3((function (param) {
                          var func$4 = Curry._1(func$3, param);
                          return function (param) {
                            var func$5 = Curry._1(func$4, param);
                            return function (param) {
                              var func$6 = Curry._1(func$5, param);
                              return function (param) {
                                return Curry._2(func$6, param, exitReason);
                              };
                            };
                          };
                        })(function (param) {
                          return stringifyEvent(stringifyHtmlElement, stringifyBasicEvent, stringifyDomEvent, param);
                        }), (function (param) {
                        return stringifySideEffect(stringifyHtmlElement, stringifyBasicEvent, stringifyDomEvent, param);
                      }), stringifyListener, stringifyOtherFailureReason) + ")");
    
  }
}

function stringifySideEffect(stringifyHtmlElement, stringifyBasicEvent, stringifyDomEvent, sideEffect) {
  if (typeof sideEffect === "number") {
    switch (sideEffect) {
      case /* InitializeClient */0 :
          return "InitializeClient";
      case /* RenderInitialLoadingOverlay */1 :
          return "RenderInitialLoadingOverlay";
      case /* RemoveDataExportWidget */2 :
          return "RemoveDataExportWidget";
      
    }
  } else {
    switch (sideEffect.TAG | 0) {
      case /* Dispatch */0 :
          var $$event = sideEffect._0;
          var func = function (param, param$1, param$2) {
            return stringifyEvent(stringifyHtmlElement, param, param$1, param$2);
          };
          var func$1 = Curry._1(func, stringifyBasicEvent);
          return "Dispatch(" + (Curry._1((function (param) {
                          return Curry._2(func$1, param, $$event);
                        }), stringifyDomEvent) + ")");
      case /* ExtractSignal */1 :
          return "ExtractSignal(STEM(client))";
      case /* AskBgToProcessDataExtractionSignal */2 :
          return "AskBgToProcessDataExtractionSignal(STEM(client), STEM(signal))";
      case /* RenderDataExportWidget */3 :
          return "RenderDataExportWidget(STEM(client), dataRecordsGroupedByFirstNode)";
      case /* RespondToBg */4 :
          return "RespondToBg(respondToBg, response)";
      
    }
  }
}

function stringifyListener(listener) {
  return "NoListener";
}

var stringifyOtherFailureReason = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason;

function mapState(mapHtmlElement$2, state) {
  if (typeof state === "number") {
    switch (state) {
      case /* Init */0 :
          return /* Init */0;
      case /* Initializing */1 :
          return /* Initializing */1;
      case /* Exiting */2 :
          return /* Exiting */2;
      
    }
  } else {
    switch (state.TAG | 0) {
      case /* ExtractingSignal */0 :
          return {
                  TAG: /* ExtractingSignal */0,
                  _0: mapHtmlElement(mapHtmlElement$2, state._0)
                };
      case /* ProcessingSignal */1 :
          return {
                  TAG: /* ProcessingSignal */1,
                  _0: mapHtmlElement(mapHtmlElement$2, state._0)
                };
      case /* SelectingDataToExport */2 :
          return {
                  TAG: /* SelectingDataToExport */2,
                  _0: mapHtmlElement(mapHtmlElement$2, state._0),
                  _1: state._1
                };
      
    }
  }
}

function mapEvent(mapHtmlElement$2, mapDomMutationRecord, mapDomEvent, $$event) {
  switch ($$event.TAG | 0) {
    case /* Initialize */0 :
        return {
                TAG: /* Initialize */0,
                _0: $$event._0
              };
    case /* BasicEventWhileDataExtraction */1 :
        return {
                TAG: /* BasicEventWhileDataExtraction */1,
                _0: $$event._0
              };
    case /* Fail */2 :
        var failure = $$event._0;
        var func = StateMachine$SmartcutsMacros.Failure.WithListener.map;
        var param = function (param$1) {
          return mapState(mapHtmlElement$2, param$1);
        };
        var func$1 = Curry._1(func, param);
        return {
                TAG: /* Fail */2,
                _0: Curry._2((function (param) {
                          var func$2 = Curry._1(func$1, param);
                          return function (param) {
                            var func$3 = Curry._1(func$2, param);
                            return function (param) {
                              return Curry._2(func$3, param, failure);
                            };
                          };
                        })(function (param) {
                          return mapEvent(mapHtmlElement$2, mapDomMutationRecord, mapDomEvent, param);
                        }), (function (param) {
                        return mapSideEffect(mapHtmlElement$2, mapDomMutationRecord, mapDomEvent, param);
                      }), (function (param) {
                        return /* NoListener */0;
                      }))
              };
    case /* DidInitializeClient */3 :
        return {
                TAG: /* DidInitializeClient */3,
                _0: mapHtmlElement(mapHtmlElement$2, $$event._0)
              };
    case /* DidExtractSignal */4 :
        return {
                TAG: /* DidExtractSignal */4,
                _0: $$event._0
              };
    case /* DidExtractDataRecords */5 :
        return {
                TAG: /* DidExtractDataRecords */5,
                _0: $$event._0
              };
    case /* Exit */6 :
        var exitReason = $$event._0;
        var func$2 = StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.map;
        var param$1 = function (param$2) {
          return mapState(mapHtmlElement$2, param$2);
        };
        var func$3 = Curry._1(func$2, param$1);
        return {
                TAG: /* Exit */6,
                _0: Curry._2((function (param) {
                          var func$4 = Curry._1(func$3, param);
                          return function (param) {
                            var func$5 = Curry._1(func$4, param);
                            return function (param) {
                              return Curry._2(func$5, param, exitReason);
                            };
                          };
                        })(function (param) {
                          return mapEvent(mapHtmlElement$2, mapDomMutationRecord, mapDomEvent, param);
                        }), (function (param) {
                        return mapSideEffect(mapHtmlElement$2, mapDomMutationRecord, mapDomEvent, param);
                      }), (function (param) {
                        return /* NoListener */0;
                      }))
              };
    
  }
}

function mapSideEffect(mapHtmlElement$2, mapDomMutationRecord, mapDomEvent, sideEffect) {
  if (typeof sideEffect === "number") {
    switch (sideEffect) {
      case /* InitializeClient */0 :
          return /* InitializeClient */0;
      case /* RenderInitialLoadingOverlay */1 :
          return /* RenderInitialLoadingOverlay */1;
      case /* RemoveDataExportWidget */2 :
          return /* RemoveDataExportWidget */2;
      
    }
  } else {
    switch (sideEffect.TAG | 0) {
      case /* Dispatch */0 :
          var $$event = sideEffect._0;
          var func = function (param, param$1, param$2) {
            return mapEvent(mapHtmlElement$2, param, param$1, param$2);
          };
          var func$1 = Curry._1(func, mapDomMutationRecord);
          return {
                  TAG: /* Dispatch */0,
                  _0: Curry._1((function (param) {
                          return Curry._2(func$1, param, $$event);
                        }), mapDomEvent)
                };
      case /* ExtractSignal */1 :
          return {
                  TAG: /* ExtractSignal */1,
                  _0: mapHtmlElement(mapHtmlElement$2, sideEffect._0)
                };
      case /* AskBgToProcessDataExtractionSignal */2 :
          return {
                  TAG: /* AskBgToProcessDataExtractionSignal */2,
                  _0: mapHtmlElement(mapHtmlElement$2, sideEffect._0),
                  _1: sideEffect._1
                };
      case /* RenderDataExportWidget */3 :
          return {
                  TAG: /* RenderDataExportWidget */3,
                  _0: mapHtmlElement(mapHtmlElement$2, sideEffect._0),
                  _1: sideEffect._1
                };
      case /* RespondToBg */4 :
          return {
                  TAG: /* RespondToBg */4,
                  _0: sideEffect._0,
                  _1: sideEffect._1
                };
      
    }
  }
}

function mapListener(param, listener) {
  return /* NoListener */0;
}

function isAnyFailEvent($$event) {
  if ($$event.TAG === /* Fail */2) {
    return true;
  } else {
    return false;
  }
}

function extractRespondToBgFromEvent($$event) {
  switch ($$event.TAG | 0) {
    case /* Initialize */0 :
        return $$event._0;
    case /* BasicEventWhileDataExtraction */1 :
        return ContentScript__StateMachine__Shared$SmartcutsMacros.extractRespondToBgFromEvent($$event._0);
    default:
      return ;
  }
}

function extractRespondToBgFromListener(listener) {
  
}

function extractRespondToBgFromSideEffect(sideEffect) {
  if (typeof sideEffect === "number" || sideEffect.TAG !== /* Dispatch */0) {
    return ;
  } else {
    return extractRespondToBgFromEvent(sideEffect._0);
  }
}

var Generic = {
  state_encode: state_encode,
  state_decode: state_decode,
  selectingDataToExport_encode: selectingDataToExport_encode,
  selectingDataToExport_decode: selectingDataToExport_decode,
  event_encode: event_encode,
  event_decode: event_decode,
  sideEffect_encode: sideEffect_encode,
  sideEffect_decode: sideEffect_decode,
  exitReason_encode: exitReason_encode,
  exitReason_decode: exitReason_decode,
  failure_encode: failure_encode,
  failure_decode: failure_decode,
  listener_encode: listener_encode,
  listener_decode: listener_decode,
  errorContext_encode: errorContext_encode,
  errorContext_decode: errorContext_decode,
  otherFailureReason_encode: otherFailureReason_encode,
  otherFailureReason_decode: otherFailureReason_decode,
  stringifyState: stringifyState,
  stringifyEvent: stringifyEvent,
  stringifySideEffect: stringifySideEffect,
  stringifyListener: stringifyListener,
  stringifyOtherFailureReason: stringifyOtherFailureReason,
  mapState: mapState,
  mapEvent: mapEvent,
  mapSideEffect: mapSideEffect,
  mapListener: mapListener,
  isAnyFailEvent: isAnyFailEvent,
  extractRespondToBgFromEvent: extractRespondToBgFromEvent,
  extractRespondToBgFromListener: extractRespondToBgFromListener,
  extractRespondToBgFromSideEffect: extractRespondToBgFromSideEffect
};

function state_encode$1(v) {
  return state_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, v);
}

function state_decode$1(v) {
  return state_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, v);
}

var ForSerialization = {
  state_encode: state_encode$1,
  state_decode: state_decode$1
};

exports.Client = Client;
exports.Signal = Signal;
exports.DataRecords = DataRecords;
exports.Generic = Generic;
exports.ForSerialization = ForSerialization;
/* STEM__Client-SmartcutsMacros Not a pure module */
